import getActions from "./actionsPopupUtils";

const foreign_worker_group_actions = (formName, isSubaccount, groupId) => {
  return getActions({
    formName,
    isSubaccount,
    groupId,
    shared: true,
    customMessage: {
      delete:
        "This ONLY deletes the group. Profiles that are a part of this group will NOT be deleted.",
    },
  });
};

export default foreign_worker_group_actions;
